import React, { Component } from 'react';
import classes from './Scratcher.module.scss';
import scratch from './Scratching2.mp3';
import Confetti from 'react-confetti'

class Scratcher extends Component {

    constructor(props) {
        super(props);
        this.isDrawing = false;
        this.lastPoint = null;
        this.isLoading = true;
        let height = props.height;
        let width = props.width
        let elementId = "audioElement" + new Date().valueOf().toString();
        this.elementId = elementId;
        let audioElement = document.createElement('audio');
        audioElement.src = scratch;
        audioElement.setAttribute("id", elementId);
        document.body.appendChild(audioElement);
        this.state = {
            visible: true,
            colors: 
             ['#f44336'
                ,'#e91e63'
                ,'#9c27b0'
                ,'#673ab7'
                ,'#3f51b5'
                ,'#2196f3'
                ,'#03a9f4'
                ,'#00bcd4'
                ,'#009688'
                ,'#4CAF50'
                ,'#8BC34A'
                ,'#CDDC39'
                ,'#FFEB3B'
                ,'#FFC107'
                ,'#FF9800'
                ,'#FF5722'
                ,'#795548'
            ],
            height: height,
            width: width,
            isMobile: null
        }
    }

    componentDidMount() {
        const canvas = this.canvas;
        canvas.width = canvas.parentElement.offsetWidth;
        canvas.height = canvas.parentElement.offsetHeight;
        canvas.addEventListener('mousedown', this.touchStart);
        canvas.addEventListener('touchstart', this.touchStart);
        canvas.addEventListener('mousemove', this.touchMove);
        canvas.addEventListener('touchmove', this.touchMove);
        canvas.addEventListener('mouseup', this.touchEnd);
        canvas.addEventListener('touchend', this.touchEnd);
        this.setOverlay(canvas);
        let isMobile = this.checkMobile();
        this.setState({
            isMobile: isMobile
        })
    }

    checkMobile() {
        let isMobile = false;
        // eslint-disable-next-line
        if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) { 
            isMobile = true;
        }
        return isMobile;
    }

    setOverlay = (canvas) => {
        this.ctx = canvas.getContext('2d');
        this.brush = new Image();
        this.brush.src = require('../../images/brush.png');
        this.cover = new Image();
        this.cover.src = this.props.overlay + '?' + new Date().getTime();
        this.cover.setAttribute('crossOrigin', '');
        this.brush.setAttribute('crossOrigin', '');
        this.brush.onload = () => {
            this.brush.setAttribute('crossOrigin', '');
        }
        this.cover.onload = () => {
            this.cover.setAttribute('crossOrigin', '');
            this.ctx.drawImage(this.cover, 0, 0, canvas.width, canvas.height);
            this.setState({
                height: canvas.height,
                widht: canvas.width
            })
            let rgb = this.getAverageRGB();
            let hex = this.rgbToHex(rgb.r, rgb.g, rgb.b);
            let newColors = [];
            for (let i = 0; i < 16; i++) {
                newColors.push(this.LightenDarkenColor(hex, i + 10))
            }
            if (newColors && newColors.length > 0) {
                this.setState({colors: newColors})
            }
            this.isLoading = false;
            this.props.onToggleLoading(false);
        }
    }

    componentWillUnmout() {
        const canvas = this.canvas;
        canvas.removeEventListener('mousedown', this.touchStart);
        canvas.removeEventListener('touchstart', this.touchStart);
        canvas.removeEventListener('mousemove', this.touchMove);
        canvas.removeEventListener('touchmove', this.touchMove);
        canvas.removeEventListener('mouseup', this.touchEnd);
        canvas.removeEventListener('touchend', this.touchEnd);
    }

    LightenDarkenColor = (col, amt) => {
        let usePound = false;
        if (col[0] === "#") {
            col = col.slice(1);
            usePound = true;
        }
        let num = parseInt(col,16);
        let r = (num >> 16) + amt;
        if (r > 255) {
            r = 255;
        } else if (r < 0) {
            r = 0;
        }
        let b = ((num >> 8) & 0x00FF) + amt;
        if (b > 255) {
            b = 255;
        } else if  (b < 0) {
            b = 0;
        }
        let g = (num & 0x0000FF) + amt;
        if (g > 255) {
            g = 255;
        } else if ( g < 0 ) {
            g = 0;
        }
        return (usePound ? "#" : "") + (g | (b << 8) | (r << 16)).toString(16);
    }

    getPosition = (event) => {
        let target = this.canvas;
        let offsetX = 0;
        let offsetY = 0;
        if (target.offsetParent !== undefined) {
            // eslint-disable-next-line 
            while (target = target.offsetParent) {
                offsetX += target.offsetLeft;
                offsetY += target.offsetTop;
            }
        }
        const x = (event.pageX || event.touches[0].clientX) - offsetX;
        const y = (event.pageY || event.touches[0].clientY) - offsetY;
        return {x, y};
    }

    touchStart = (event) => {
        // coment this out START for audio removal
        if (!this.isDrawing) {
            this.audio = document.getElementById(this.elementId);
            this.audio.muted = false;
            this.audio.play();
            if (this.state.isMobile) {
                let userAgent = window.navigator.userAgent;
                if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i)) {
                    this.audio.currentTime = 0;
                } else {
                    this.checkPlaying();
                }
            } else {
                this.audio.currentTime = 0;
            }
        }
        // coment this out END for audio removal
        this.isDrawing = true;
        this.lastPoint = this.getPosition(event);
        this.ctx.globalCompositeOperation = 'destination-out';
    }

    checkPlaying = () => {
        if ((this.audio && (this.audio.currentTime !== this.audio.duration)) || (this.audio && this.audio.currentTime === 0)) {
            this.playing = true;
        } else {
            this.playing = false;
        }
    }

    touchMove = (event) => {
        const parentNode = document.getElementById('canvasContainer');
        const canvasChild = document.getElementById('scratchCanvas');
        const hasChild = parentNode.contains(canvasChild);
        // comment this out START for audio removal
        this.checkPlaying();
        if (event && this.isDrawing) {
            if (hasChild && !this.playing) {
                this.audio = document.getElementById(this.elementId)
                this.audio.play();
            } else if (this.playing && !hasChild) {
                this.stopAudio();
            }
        } else {
            if (this.audio && this.playing) {
                this.stopAudio();
            }
        }
        // comment this out END
        if (!this.isDrawing) return;
        event.preventDefault();
        const ctx = this.ctx;
        const a = this.lastPoint;
        const b = this.getPosition(event);
        const dist = Math.sqrt(Math.pow(b.x - a.x, 2) + Math.pow(b.y - a.y, 2));
        const angle = Math.atan2(b.x - a.x, b.y - a.y);
        const offsetX = this.brush.width / 2;
        const offsetY = this.brush.height / 2;
        for (let x, y, i = 0; i < dist; i++) {
            x = a.x + (Math.sin(angle) * i) - offsetX;
            y = a.y + (Math.cos(angle) * i) - offsetY;
            ctx.drawImage(this.brush, x, y);
        }

        this.lastPoint = b;
        this.handlePercentage(this.getFilledInPixels(32));
    }

    touchEnd = (event) => {
        this.isDrawing = false;
        if (this.audio) {
            this.stopAudio();
        }
    }

    stopAudio = () => {
        this.audio.pause();
        this.audio.currentTime = 0;
    }

    getFilledInPixels = (stride) => {
        if (!stride || stride < 1) {
            stride = 1;
        }
        let pixels = this.ctx.getImageData(0, 0, this.canvas.width, this.canvas.height);
        let pdata = pixels.data;
        let l = pdata.length;
        let total = (l / stride);
        let count = 0;
        for (var i = count = 0; i < l; i += stride) {
            if (parseInt(pdata[i]) === 0) {
                count++;
            }
        }
        return Math.round((count / total) * 100);
    }

    getAverageRGB = () => {
        let data;
        let defaultRGB = {r:0,g:0,b:0};
        const blockSize = 5; 
        let i = -4;
        let length;
        let rgb = {r:0,g:0,b:0};
        let count = 0;
        try {
            data = this.ctx.getImageData(0, 0, this.canvas.width, this.canvas.height);
        } catch(e) {
            /* security error, img on diff domain */
            return defaultRGB;
        }
        length = data.data.length;
        while ( (i += blockSize * 4) < length ) {
            ++count;
            rgb.r += data.data[i];
            rgb.g += data.data[i+1];
            rgb.b += data.data[i+2];
        }
        // ~~ used to floor values
        rgb.r = ~~(rgb.r/count);
        rgb.g = ~~(rgb.g/count);
        rgb.b = ~~(rgb.b/count);
        // return this.rgbToHex(~~(rgb.r/count), ~~(rgb.g/count), ~~(rgb.b/count));
        return rgb;

    }     

    componentToHex = (c) => {
        let hex = c.toString(16);
        return hex.length === 1 ? "0" + hex : hex;
    }
      
    rgbToHex = (r, g, b) => {
        return "#" + this.componentToHex(r) + this.componentToHex(g) + this.componentToHex(b);
    }

    handlePercentage = (filledInPixels) => {
        filledInPixels = filledInPixels || 0;
        let parentNode = document.getElementById('canvasContainer');
        let canvasChild = document.getElementById('scratchCanvas');
        if (filledInPixels > 45 && parentNode.contains(canvasChild)) {
            this.canvas.style.opacity = '0';
            setTimeout(() => { 
                if(parentNode.contains(canvasChild)) {
                    parentNode.removeChild(this.canvas);
                    this.setConf();
                }
            }, 500);
            return;
        }
    }

    setConf = () => {
        setTimeout(() => { 
            this.props.onUpdateStatus(1)
            this.setState({visible: false})
        }, 100);
    }

    render() {
        let width = this.state.width;
        if (this.state.isMobile) {
            width = this.state.width;
        } else {
            width = this.props.width > 414 ? 414 : this.props.width
        }
        let conf =  <Confetti colors={this.state.colors} className={!this.state.visible ? classes.FadeOut : ''} height={this.state.height} width={width}></Confetti>;
        return ( 
            <div style={
                {
                    position: 'relative',
                    width: width,
                    maxWidth: '414px',
                    height: '100%',
                    maxHeight: '736px',
                    top: 0
                }
            } id={'canvasContainer'}>
                <canvas className={classes.List} style={
                    {
                        position: 'absolute',
                        zIndex: 2000,
                        maxWidth: '414px',
                        width: '100%',
                        height: '100%',
                        maxHeight: '736px',
                        top: 0
                    }
                }
                ref={el => this.canvas = el}
                id={'scratchCanvas'} /> 
                <div className={
                        [
                            classes.Secret,
                            classes.Absolute,
                            classes.Fill,
                            classes.NoSelect,
                            classes.Flex,
                            classes.JustifyCenter,
                            classes.ItemsCenter
                        ].join()
                    }> 
                    {
                        this.isLoading ?
                        '' :
                        <div >{conf}{this.props.children}</div>} 
                </div> 
            </div>
        );
    }
}

export default Scratcher;